import CircularProgress from '@material-ui/core/CircularProgress'
import { type WithStyles, withStyles } from '@material-ui/core/styles'
import Step, { type StepPropsType } from '@merchant/views/step'
import { loadingStyles } from './loading_styles'

type LoadingPropsType = StepPropsType & WithStyles<typeof loadingStyles>

class LoadingClass extends Step<LoadingPropsType> {
  sendData = false

  render() {
    const { classes } = this.props

    return (
      <div className={classes.busy}>
        <CircularProgress size={120} thickness={1} />
      </div>
    )
  }
}

export const Loading = withStyles(loadingStyles)(LoadingClass)
